<template>
  <div>
    <div>
      <div class="lg:flex">
        <h2 class="text-2xl font-bold text-black">
          {{ $t('postTraining.dtg.warranty.heading') }}
        </h2>
        <div v-if="hasNotReadWarranty" class="lg:ml-8 lg:-mt-12">
          <div class="bg-ricoma-blue-300 p-4 text-white md:w-80">
            <p class="font-bold">
              {{ $t('postTraining.dtg.warranty.card.heading') }}
            </p>
            <p class="">
              {{ $t('postTraining.dtg.warranty.card.text') }}
            </p>
          </div>
          <div class="arrow-down ml-8"></div>
        </div>
      </div>
      <div class="border-t-2 border-b-2 border-gray-500 mb-8 py-4">
        <div class="lg:px-8 h-76 overflow-y-auto">
          <h2 class="text-xl font-bold text-ricoma-blue-300 mb-4">
            {{ $t('postTraining.dtg.warranty.subheading') }}
          </h2>
          <ul class="list-disc ml-8">
            <li
              v-for="index in 14"
              :key="index"
              class="mb-4"
              v-html="$t('postTraining.dtg.warranty.list.t-' + index)"
            ></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex text-center justify-center lg:justify-between flex-col lg:flex-row">
      <div class="text-center mx-auto lg:ml-0 lg:text-left">
        <a :href="pdfPath" target="_blank" download class="flex cursor-pointer">
          <VSvgIcon name="download" width="30" height="30" class="text-black" />
          {{ $t('postTraining.dtg.warranty.pdf') }}
        </a>
      </div>
      <div>
        <button
          @click="changeHasNotReadWarranty()"
          class="my-4 lg:my-0 py-3 px-8 lg:px-16 mx-auto rounded-full text-sm font-semibold text-white uppercase"
          :class="
            !hasNotReadWarranty
              ? 'cursor-default bg-black hover:bg-black '
              : 'bg-ricoma-blue-300 hover:bg-ricoma-blue-300-hover'
          "
        >
          <div class="flex justify-center items-center">
            <VSvgIcon
              v-if="!hasNotReadWarranty"
              name="check-circle"
              width="20"
              height="20"
              class="text-white mr-1"
            />
            {{ $t('postTraining.dtg.warranty.button') }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';
export default {
  name: 'WarrantyDtg',
  components: { VSvgIcon },
  props: {
    hasNotReadWarranty: {
      type: Boolean,
      require: true,
      default: false,
    },
  },
  computed: {
    pdfPath() {
      return `${process.env.BASE_URL}warranty_dtg_${this.$language.code}.pdf`;
    },
  },
  methods: {
    changeHasNotReadWarranty() {
      this.$emit('handleHasNotReadWarranty');
    },
    downloadPDF() {},
  },
  async mounted() {},
  created() {},
};
</script>
